import React from 'react';

const GlobalFilter = ({ preGlobalFilteredRows, globalFilter, setGlobalFilter }) => {
  const count = preGlobalFilteredRows.length;

  return (
    <div className="mb-4">
      <label className="block text-gray-700 font-semibold mb-2">Search</label>
      <input
        value={globalFilter || ''}
        onChange={(e) => setGlobalFilter(e.target.value || undefined)}
        placeholder={`${count} records...`}
        className="w-full p-3 border rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
  );
};

export default GlobalFilter;